/**
 * 时间窗口选项配置
 *
 * 用于 Dashboard 统计数据的时间范围选择
 */
export const TIME_WINDOW_OPTIONS = [
  { value: 7, label: '7d' },
  { value: 30, label: '30d' },
  { value: 180, label: '180d' },
  { value: 360, label: '360d' },
] as const;

/**
 * 时间窗口选择器标签
 */
export const TIME_WINDOW_LABEL = 'Active Device Window';
